(function() {
  'use strict';

  function initScrollReveal() {
    const mediaSelector = 'img, picture, video, figure, .media, [class*="media"], [class*="gallery"], [class*="banner"], [class*="hero"], .product-media-container';
    const targets = document.querySelectorAll('h1, h2, h3, h4, p, blockquote, .rte, [class*="price"]');
    targets.forEach((el) => {
      if (el.closest(mediaSelector)) return;
      if (el.classList.contains('cp-reveal')) return;
      el.classList.add('cp-reveal');
      const idx = Array.from(el.parentElement ? el.parentElement.children : []).indexOf(el);
      if (idx > 0 && idx <= 4) el.classList.add('cp-reveal--delay-' + idx);
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('cp-reveal--visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -24px 0px' });
    document.querySelectorAll('.cp-reveal').forEach(el => io.observe(el));
  }

  function initProgressBar() {
    const bar = document.createElement('div');
    bar.className = 'cp-progress-bar';
    document.body.appendChild(bar);
    window.addEventListener('scroll', () => {
      const d = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (d > 0 ? (window.scrollY / d) * 100 : 0) + '%';
    }, { passive: true });
  }

  function initPageTransitions() {
    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:#fff;z-index:99998;pointer-events:none;opacity:0;transition:opacity 0.4s ease';
    document.body.appendChild(overlay);
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto') || href.startsWith('tel')) return;
      try { if (new URL(href, location.href).hostname !== location.hostname) return; } catch(err) { return; }
      e.preventDefault();
      overlay.style.opacity = '1';
      setTimeout(() => { window.location.href = href; }, 380);
    });
  }

  function initDrawer() {

    // ---- Backdrop ----
    const backdrop = document.createElement('div');
    backdrop.className = 'cp-drawer-backdrop';

    // ---- Drawer ----
    const drawer = document.createElement('div');
    drawer.className = 'cp-drawer';
    drawer.setAttribute('role', 'navigation');
    drawer.setAttribute('aria-label', 'Navigatie');

    // Bouw drawer volledig via innerHTML — alles in één keer
    // Zodat alle elementen in de DOM zitten voor we listeners toevoegen
    const existingLogo = document.querySelector(
      '.header-logo img, .header-logo svg, header-component img, header-component svg, [class*="logo"] img, [class*="logo"] svg'
    );

    let logoHTML = '<a href="/" class="cp-drawer__logo-text">Chris Peeters</a>';
    if (existingLogo && existingLogo.tagName === 'IMG') {
      logoHTML = `<a href="/"><img src="${existingLogo.src}" alt="Chris Peeters" style="max-height:20px;width:auto;display:block;filter:brightness(0) invert(1);"></a>`;
    }

    drawer.innerHTML = `
      <!-- Logo + zoek rechtsboven -->
      <div class="cp-drawer__logo-wrap">
        ${logoHTML}
        <button id="cp-search-btn" class="cp-drawer__search-btn" aria-label="Zoeken" type="button">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="7"/>
            <line x1="16.5" y1="16.5" x2="22" y2="22"/>
          </svg>
        </button>
      </div>

      <!-- Zoekbalk -->
      <div id="cp-search-bar" class="cp-drawer__search-bar">
        <form action="/search" method="get" class="cp-drawer__search-form">
          <input
            id="cp-search-input"
            type="search"
            name="q"
            class="cp-drawer__search-input"
            placeholder="Zoek naar een horloge..."
            autocomplete="off"
            spellcheck="false"
          />
          <button type="submit" class="cp-drawer__search-submit" aria-label="Zoek">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </button>
        </form>
      </div>

      <!-- Spacer -->
      <div class="cp-drawer__top-spacer"></div>

      <!-- Nav -->
      <span class="cp-drawer__category">Home</span>
      <ul class="cp-drawer__nav">
        <li><a href="/">Homepage</a></li>
      </ul>

      <hr class="cp-drawer__divider">

      <span class="cp-drawer__category">Collectie</span>
      <ul class="cp-drawer__nav">
        <li><a href="/pages/the-astra">The Astra</a></li>
        <li><a href="/collections/all">Alle Horloges</a></li>
      </ul>

      <hr class="cp-drawer__divider">

      <span class="cp-drawer__category">Het Merk</span>
      <ul class="cp-drawer__nav">
        <li><a href="/pages/the-craft">The Craft</a></li>
        <li><a href="/pages/certificaat">Certificaat</a></li>
        <li><a href="/pages/over-ons">Over Ons</a></li>
      </ul>

      <hr class="cp-drawer__divider">

      <span class="cp-drawer__category">Service</span>
      <ul class="cp-drawer__nav">
        <li><a href="/pages/contact">Contact</a></li>
        <li><a href="/pages/request-access">Request Access</a></li>
      </ul>

      <div class="cp-drawer__footer">
        <a href="mailto:chrispeeters.info@gmail.com">chrispeeters.info@gmail.com</a>
        <a href="/">chrispeetersofficial.com</a>
      </div>
    `;

    // ---- Trigger ----
    const trigger = document.createElement('button');
    trigger.className = 'cp-menu-trigger';
    trigger.setAttribute('aria-label', 'Menu');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('type', 'button');
    trigger.innerHTML = '<span></span><span></span>';

    // Voeg alles toe aan de DOM
    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);
    document.body.appendChild(trigger);

    // Nu pas listeners toevoegen — elementen staan nu in de DOM
    let open = false;

    function openDrawer() {
      open = true;
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      open = false;
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      // Sluit zoekveld ook
      const bar = document.getElementById('cp-search-bar');
      if (bar) bar.classList.remove('is-open');
    }

    trigger.addEventListener('click', () => open ? closeDrawer() : openDrawer());
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', closeDrawer));

    // ---- Zoek toggle — nu pakt getElementById het correct op ----
    const searchBtn = document.getElementById('cp-search-btn');
    const searchBar = document.getElementById('cp-search-bar');
    const searchInput = document.getElementById('cp-search-input');

    if (searchBtn && searchBar && searchInput) {
      let searchOpen = false;

      searchBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        searchOpen = !searchOpen;

        if (searchOpen) {
          searchBar.classList.add('is-open');
          // Focus na animatie
          setTimeout(() => searchInput.focus(), 350);
        } else {
          searchBar.classList.remove('is-open');
          searchInput.value = '';
        }
      });

      // Sluit zoekveld bij Escape
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          searchOpen = false;
          searchBar.classList.remove('is-open');
          searchInput.value = '';
        }
      });
    }
  }

  function init() {
    initScrollReveal();
    initProgressBar();
    initPageTransitions();
    initDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
